class Options {
    /**
     * @param {Modal} modal
     * @param formData
     */
    constructor({modal, formData = {}}) {
        this.modal = modal;
        this.formData = formData;
        this.selectors = {
            wrap: '[data-modal-wrap-content]',
            requiredOption: '[data-required-option]',
            btn: '[data-cart-add]',
            btnDisable: 'btn_disable',
            input: '[data-price]',
        };
        this.render();
    }

    static run(data) {
        return new Options(data);
    }

    toggleBtn() {
        const requiredList = this.modal.activeModal.querySelectorAll(
            `${this.selectors.wrap} ${this.selectors.requiredOption}`,
        );

        if (!requiredList.length) {
            return;
        }

        const inputs = this.modal.activeModal.querySelectorAll(
            `${this.selectors.wrap} ${this.selectors.input}:checked`,
        );

        const btn = this.modal.activeModal.querySelector(`${this.selectors.wrap} ${this.selectors.btn}`);

        if (!btn) {
            return;
        }

        if (inputs.length) {
            btn.classList.remove(this.selectors.btnDisable);
        } else {
            btn.classList.add(this.selectors.btnDisable);
        }
    }

    /**
     * @param {Event} e
     */
    onChange(e) {
        let inputElem = e.target.closest(`${this.selectors.wrap} ${this.selectors.input}`);

        if (!inputElem) {
            return;
        }

        this.toggleBtn();
    }

    /** @return void */
    eventListeners() {
        document.addEventListener('change', (e) => this.onChange(e));
    }

    render() {
        this.toggleBtn();
        this.eventListeners();
    }
}

export default Options;
